import { post_middleware_query, post_middleware_query_items } from "services/middleware_services"
import useCancelToken from "hooks/useCancelToken"
import Swal from "sweetalert2"
import useAuthorizer from "./useAuthorizer"
import { useContext } from "react"
import AuthContext from "store/context/PublicContext"

interface IMiddlewareQuery {
  skipRecords: number
  maxRecords: number
  entityType: string
  filter?: any
  project?: Array<string>
}

interface IMiddlewareQueryItems {
  filter: Array<string>
  page?: number
  excludeZeros?: boolean
}

const usePostMiddlewareQuery = () => {
  const { user } = useContext(AuthContext)
  const { newCancelToken, isCancel } = useCancelToken()
  const { logout_user_action } = useAuthorizer()

  const post_middleware_query_action = async (body: IMiddlewareQuery) => {
    try {
      return await post_middleware_query(body, user?.token, newCancelToken())
    } catch (error: any) {
      if (isCancel(error)) return
      Swal.fire({
        title: "Error",
        text: error?.response?.data?.message?.error,
        icon: "error",
      })
      logout_user_action()
    }
  }

  const post_middleware_query_items_action = async (body: IMiddlewareQueryItems, channel: string) => {
    try {
      return await post_middleware_query_items(body, channel, user?.token, newCancelToken())
    } catch (error: any) {
      if (isCancel(error)) return
      Swal.fire({
        title: "Error",
        text: error?.response?.data?.message?.error,
        icon: "error",
      })
      logout_user_action()
    }
  }

  return {
    post_middleware_query_action,
    post_middleware_query_items_action,
  }
}

export default usePostMiddlewareQuery
